export function registerServiceWorker() {
  if ('serviceWorker' in navigator && import.meta.env.VITE_ENABLE_SERVICE_WORKER === 'true') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.warn('SW registration failed:', err)
      })
    })
  }
}
